import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import {MatChipsModule} from '@angular/material/chips';
import { DailyLogsRoutingModule } from './daily-logs-routing.module';
import { DailyLogsComponent } from './daily-logs.component';
import { CommonSectionModule } from 'src/app/common-section/common-section.module';
import { ViewDailyLogComponent } from './view-daily-log/view-daily-log.component';
import { DailyLogDetailComponent } from './daily-log-detail/daily-log-detail.component';
// import { SingleDailyLogComponent } from './single-daily-log/single-daily-log.component';
import { CaptureMediaComponent } from './capture-media/capture-media.component';
import { DailyLogsPdfComponent } from './daily-logs-pdf/daily-logs-pdf.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { DailyLogsCommentComponent } from './daily-logs-comment/daily-logs-comment.component';
import {MatExpansionModule} from '@angular/material/expansion';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CommentDailyLogComponent } from './comment-daily-log/comment-daily-log.component';
@NgModule({
  declarations: [
    DailyLogsComponent,
    ViewDailyLogComponent,
    DailyLogDetailComponent,
    // SingleDailyLogComponent,
    CaptureMediaComponent,
    DailyLogsPdfComponent,
    DailyLogsCommentComponent,
    CommentDailyLogComponent
  ],
  imports: [
    CommonModule,
    MatChipsModule,
    MatTableModule,
    DailyLogsRoutingModule,
    CommonSectionModule,
    FlexLayoutModule,
    MatExpansionModule,
    MatDatepickerModule
  ],
  exports:[
    DailyLogsComponent,
    ViewDailyLogComponent,
    DailyLogDetailComponent,
    // SingleDailyLogComponent,
    CaptureMediaComponent,
    DailyLogsPdfComponent,
    DailyLogsCommentComponent,
    CommentDailyLogComponent
  ]
})
export class DailyLogsModule { }
